import debounce from 'lodash/debounce';

export default class TextOverflow {
    constructor (el) {
        if (!el) return;

        this.container = el;
        this.contentContainer = this.container.querySelector('.js-text-overflow-content-container');
        this.content = this.container.querySelector('.js-text-overflow-content');
        this.controlContainer = this.container.querySelector('.js-text-overflow-control-toggle-container');
        this.control = this.controlContainer.querySelector('.js-text-overflow-control-toggle');
        this.condtionallyRenderOverflowControlUIDebounced = debounce(this.condtionallyRenderOverflowControlUI.bind(this), 50);

        if (this.contentContainer && this.content && this.controlContainer && this.control) {
            this.init();
        }
    }

    init () {
        this.condtionallyRenderOverflowControlUI();

        window.addEventListener('resize', this.condtionallyRenderOverflowControlUIDebounced);
        this.control.addEventListener('click', event => this.toggleOverflow(event));
    }

    condtionallyRenderOverflowControlUI () {
        if (this.control.ariaExpanded === 'false') {
            if (this.content.getBoundingClientRect().height > this.contentContainer.getBoundingClientRect().height) {
                this.controlContainer.classList.remove('hidden');
            } else {
                this.controlContainer.classList.add('hidden');
            }
        }
    }

    toggleOverflow (event) {
        const control = event.target.closest('.js-text-overflow-control-toggle');

        if (control.ariaExpanded === 'true') {
            control.ariaExpanded = false;
            this.collapse();
        } else {
            control.ariaExpanded = true;
            this.expand();
        }
    }

    expand () {
        this.contentContainer.style.height = window.getComputedStyle(this.content).height;

        window.parseFloat(window.getComputedStyle(this.contentContainer).transitionDuration.replace('s', '') * 1000);

        setTimeout(() => {
            // Setting the height to `auto` so viewport changes do not necessitate a recalculation.
            this.contentContainer.style.height = 'auto';
        }, window.parseFloat(window.getComputedStyle(this.contentContainer).transitionDuration.replace('s', '') * 1000))
    }

    collapse () {
        this.contentContainer.style.height = window.getComputedStyle(this.content).height;

        // Allows the `contentContainer` height to be set to a pixel value prior to removing it - ensures transition runs.
        setTimeout(() => {
            this.contentContainer.style.height = null;
        }, 0);
    }
}